/* eslint-disable react/prop-types */
import React from 'react';
import { Section, F } from '../CommonUI';

/**
 * Tab 2: Official Details component
 * Extracted from EmployeeMaster main file to improve maintainability.
 */
function OfficialDetailsTab({ d, ch, off, opts }) {
  const isBank =
    d.payMode === 'HPMOD0001' ||
    (d.payMode && String(d.payMode).toLowerCase().includes('bank'));
  const bankOff = off || !isBank;
  const isTravelEligible = d.travelEligibility === 'Yes';
  const travelOff = off || !isTravelEligible;

  return (
    <div className="tb anim-fade">
      <div className="o-row">
        {/* Column 1: Bank Details */}
        <div className="o-stack">
          <Section
            title="Bank Details"
            cols={1}
            icon={
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect
                  x="2"
                  y="5"
                  width="20"
                  height="16"
                  rx="2"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path d="M2 10h20" stroke="currentColor" strokeWidth="2" />
              </svg>
            }
          >
            <F
              label="Pay Mode"
              name="payMode"
              value={d.payMode}
              onChange={ch}
              options={opts.payMode}
              disabled={off}
            />
            <F
              label="Bank Code"
              name="bankCode"
              value={d.bankCode}
              onChange={ch}
              options={opts.bankCode}
              disabled={bankOff}
              required={isBank}
            />
            <F
              label="Bank Branch"
              name="bankBranch"
              value={d.bankBranch}
              onChange={ch}
              options={opts.bankBranch}
              disabled={bankOff}
              required={isBank}
            />
            <F
              label="IBAN / Ac No."
              name="ibanAcNo"
              value={d.ibanAcNo}
              onChange={ch}
              disabled={bankOff}
              required={isBank}
              maxLength={50}
            />
            <F
              label="A/c Name"
              name="acName"
              value={d.acName}
              onChange={ch}
              disabled={bankOff}
              required={isBank}
              maxLength={50}
              pattern="^[a-zA-Z0-9\s.\-&()]*$"
            />
          </Section>
        </div>

        {/* Column 2: Payment Details */}
        <div className="o-stack">
          <Section
            title="Payment Details"
            cols={1}
            icon={
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M12 6v6l4 2"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            }
          >
            <F
              label="Pay Currency"
              name="payCurrency"
              value={d.payCurrency}
              onChange={ch}
              options={opts.payCurrency}
              disabled={off}
            />
            <F
              label="Pay Group"
              name="payGroup"
              value={d.payGroup}
              onChange={ch}
              options={opts.payGroup}
              disabled={bankOff}
              required={isBank}
            />
            <F
              label="WPS No."
              name="wpsNo"
              value={d.wpsNo}
              onChange={ch}
              disabled={off}
              maxLength={50}
            />
            <F
              label="Finance Code"
              name="financeCode"
              value={d.financeCode}
              onChange={ch}
              disabled={off}
              maxLength={10}
            />
            <F
              label="OT Eligibility"
              name="otEligibility"
              value={d.otEligibility}
              onChange={ch}
              radioOptions={['Yes', 'No']}
              disabled={off}
            />
          </Section>
        </div>

        {/* Column 3: Dates & Accruals */}
        <div className="o-stack">
          <Section
            title="Dates"
            cols={1}
            icon={
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <rect
                  x="3"
                  y="4"
                  width="18"
                  height="18"
                  rx="2"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M16 2v4M8 2v4M3 10h18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            }
          >
            <F
              label="Hire Date"
              name="hireDate"
              value={d.hireDate}
              onChange={ch}
              type="date"
              disabled={off}
            />
            <F
              label="ReHire Date"
              name="reHireDate"
              value={d.reHireDate}
              onChange={ch}
              type="date"
              disabled={off}
            />
            <F
              label="Validity"
              name="validity"
              value={d.validity}
              onChange={ch}
              type="date"
              disabled={off}
            />
          </Section>

          <Section
            title="Accruals"
            cols={2}
            icon={
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
          >
            <F
              check="Indemnity"
              name="indemnity"
              value={d.indemnity}
              onChange={ch}
              disabled={off}
            />
            <F
              check="Leave Fare"
              name="leaveFare"
              value={d.leaveFare}
              onChange={ch}
              disabled={off}
            />
            <F
              check="Leave Salary"
              name="leaveSalary"
              value={d.leaveSalary}
              onChange={ch}
              disabled={off}
            />
            <F
              check="Bonus"
              name="bonus"
              value={d.bonus}
              onChange={ch}
              disabled={off}
            />
          </Section>
        </div>

        {/* Column 4: Travelling */}
        <div className="o-stack">
          <Section
            title="Travelling"
            cols={1}
            icon={
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
          >
            <F
              label="Eligibility"
              name="travelEligibility"
              value={d.travelEligibility}
              onChange={ch}
              radioOptions={['Yes', 'No']}
              disabled={off}
            />
            <F
              label="Tickets (Contract)"
              name="ticketsContract"
              value={d.ticketsContract}
              onChange={ch}
              options={opts.ticketsContract}
              disabled={travelOff}
              required={isTravelEligible}
            />
            <F
              label="Tickets (Actual)"
              name="ticketsActual"
              value={d.ticketsActual}
              onChange={ch}
              options={opts.ticketsActual}
              disabled={travelOff}
              required={isTravelEligible}
            />
            <F
              label="Travel Sector"
              name="travelSector"
              value={d.travelSector}
              onChange={ch}
              options={opts.travelSector}
              disabled={travelOff}
              required={isTravelEligible}
            />
            <F
              label="Travel Class"
              name="travelClass"
              value={d.travelClass}
              onChange={ch}
              options={opts.travelClass}
              disabled={travelOff}
              required={isTravelEligible}
            />
          </Section>
        </div>
      </div>

      <div className="o-row-3" style={{ marginTop: '16px' }}>
        <Section
          title="Separation"
          cols={1}
          icon={
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4m7 14l5-5-5-5m5 5H9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        >
          <F
            label="Accrual Type"
            name="accrualType"
            value={d.accrualType}
            onChange={ch}
            options={opts.accrualType}
            disabled={off}
          />
          <F
            label="Notice Days"
            name="noticeDays"
            type="number"
            value={d.noticeDays}
            onChange={ch}
            min={0}
            step={1}
            disabled={off}
          />
        </Section>

        <Section
          title="Annual Leave"
          cols={1}
          icon={
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
          }
        >
          <F
            label="Days"
            name="annualLeaveDays"
            value={d.annualLeaveDays}
            onChange={ch}
            options={opts.annualLeaveDays}
            disabled={off}
          />
          <F
            label="Carry Over"
            name="carryOver"
            type="number"
            value={d.carryOver}
            onChange={ch}
            min={0}
            step={1}
            disabled={off}
          />
        </Section>

        <Section
          title="Bonus"
          cols={1}
          icon={
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        >
          <F
            label="Bonus Scheme"
            name="bonusScheme"
            value={d.bonusScheme}
            onChange={ch}
            options={opts.bonusScheme}
            disabled={off}
          />
          <F
            label="PCM Scheme"
            name="pcmScheme"
            value={d.pcmScheme}
            onChange={ch}
            options={opts.pcmScheme}
            disabled={off}
          />
        </Section>
      </div>
    </div>
  );
}

export default OfficialDetailsTab;
